/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React from 'react';
import { observer } from 'mobx-react';
import { Card } from '@react/react-spectrum/Card';
import { interpretKey } from '../../utils/eventUtil';

import AppTileHeader from './header';
import AppTileFooter from '../footer';
import './index.scss';

export default observer((({
    app, appSectionFilter, className, sectionHeader,
    subSectionFilter, appSection, layoutId,
}) => {
    const selectedField = app.appSectionBasedFields.find((
        { appSectionFilter: appSectionFilterArray }
    ) => appSectionFilterArray.includes(appSectionFilter));
    const { onAppAction, actionIds } = app;

    if (!selectedField) {
        return [];
    }

    const cardContextId = `${String(app.sapcode).toUpperCase()}_${app.codexVersion}`;

    return (
        <Card
            className={className}
            allowsSelection={false}
            tabIndex={0}
            onMouseDown={(e) => { e.preventDefault(); }}
            onKeyDown={interpretKey({
                onEnter: [() => onAppAction(actionIds.select, app),
                    true,
                ],
            })}
            role="link">
            <div
                className={`appTile_container ${cardContextId}`}
                render-guid={cardContextId}
            >
                <AppTileHeader
                    app={app}
                    appSectionBasedFields={selectedField}
                    sectionHeader={sectionHeader}
                    subSectionFilter={subSectionFilter}
                    appSectionFilter={appSectionFilter}
                    appSection={appSection}
                    layoutId={layoutId} />

                <AppTileFooter
                    app={app}
                    appSectionBasedFields={selectedField}
                    appSectionFilter={appSectionFilter}
                    sectionHeader={sectionHeader}
                    layoutId={layoutId} />
            </div>
        </Card>
    );
}
));
